import React from "react";
import Icon from "../../../components/AppIcon";

const ClusterOverviewCard = ({ cluster }) => {
  const getProgressColor = (percentage) => {
    if (percentage >= 80) return "text-success";
    if (percentage >= 50) return "text-warning";
    return "text-error";
  };

  const getStatusColor = (status) => {
    if (status === "complete") return "bg-success/10 text-success";
    if (status === "in-progress") return "bg-warning/10 text-warning";
    return "bg-muted text-muted-foreground";
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 hover:shadow-lg transition-all duration-250">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
            {cluster?.name}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground">
            {cluster?.projects?.name || "N/A"}
          </p>
        </div>
        <div
          className={`px-3 py-1 rounded-lg text-xs font-medium ${getStatusColor(
            cluster?.status
          )}`}
        >
          {cluster?.status === "complete"
            ? "Complete"
            : cluster?.status === "in-progress"
            ? "In Progress"
            : "Pending"}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 md:gap-4 mb-4">
        <div className="bg-muted rounded-lg p-3">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Target" size={16} className="text-primary" />
            <span className="text-xs text-muted-foreground">Daily Target</span>
          </div>
          <p className="text-xl md:text-2xl font-semibold text-foreground">
            {cluster?.dailyTarget}
          </p>
        </div>

        <div className="bg-muted rounded-lg p-3">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="CheckCircle2" size={16} className="text-success" />
            <span className="text-xs text-muted-foreground">Completed</span>
          </div>
          <p className="text-xl md:text-2xl font-semibold text-foreground">
            {cluster?.completed}
          </p>
        </div>
      </div>
      <div className="space-y-3">
        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs md:text-sm text-muted-foreground">
              Overall Progress
            </span>
            <span
              className={`text-sm md:text-base font-semibold ${getProgressColor(
                cluster?.overallProgress
              )}`}
            >
              {cluster?.overallProgress}%
            </span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div
              className="bg-primary rounded-full h-2 transition-all duration-500"
              style={{ width: `${cluster?.overallProgress}%` }}
            />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-2">
          {[
            {
              label: "Survey",
              value: cluster?.surveyComplete,
              icon: "ClipboardList",
            },
            { label: "Civil", value: cluster?.civilComplete, icon: "HardHat" },
            {
              label: "Technical",
              value: cluster?.technicalComplete,
              icon: "Wrench",
            },
          ]?.map((phase) => (
            <div key={phase?.label} className="text-center">
              <div className="flex items-center justify-center gap-1 mb-1">
                <Icon name={phase?.icon} size={14} className="text-primary" />
                <span className="text-xs text-muted-foreground">
                  {phase?.label}
                </span>
              </div>
              <p className="text-sm md:text-base font-semibold text-foreground">
                {phase?.value}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-xs md:text-sm">
          <div className="flex items-center gap-2">
            <Icon name="Users" size={16} className="text-muted-foreground" />
            <span className="text-muted-foreground">Team Members:</span>
            <span className="font-semibold text-foreground">
              {cluster?.teamMembers}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Calendar" size={16} className="text-muted-foreground" />
            <span className="text-muted-foreground">Updated:</span>
            <span className="font-semibold text-foreground">
              {cluster?.lastUpdated}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClusterOverviewCard;
